<template>
  <div class="shimmer" :class="{ circle }" :style="{
    width,
    height,
    borderRadius: circle ? '50%' : '4px'
  }"></div>

</template>

<script>
export default {
  name: 'Shimmer',
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '20px'
    },
    circle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.shimmer {
  background: #f6f7f8;
  background-image: linear-gradient(to right,
      #f6f7f8 0%,
      #edeef1 20%,
      #f6f7f8 40%,
      #f6f7f8 100%);
  background-repeat: no-repeat;
  background-size: 800px 104px;
  display: inline-block;
  position: relative;
  animation: shimmer 1.2s infinite linear;
}

@keyframes shimmer {
  0% {
    background-position: -800px 0;
  }

  100% {
    background-position: 800px 0;
  }
}

.circle {
  border-radius: 50% !important;
}
</style>
